import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = {
  key: 0,
  class: "grid-col-xs-11 grid-col-md-12"
}
const _hoisted_3 = {
  key: 1,
  class: "grid-col-xs-11 grid-col-md-12"
}
const _hoisted_4 = {
  key: 2,
  class: "grid-col-xs-11 grid-col-lg-6"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3 mb-4" }, "Descubre Imágenes que Inspiran", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Busca y encuentra imágenes asombrosas para cualquier proyecto. Simplemente ingresa una palabra clave para comenzar. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "searchTerm",
  class: "container-greet d-flex mb-3"
}, "¿Qué estás buscando? ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary my-3"
}, "Buscar", -1)
const _hoisted_9 = {
  key: 3,
  class: "grid-col-xs-11 grid-col-lg-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingFile = _resolveComponent("LoadingFile")!
  const _component_ErrorFile = _resolveComponent("ErrorFile")!
  const _component_CarouselFile = _resolveComponent("CarouselFile")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("article", _hoisted_2, [
          _createVNode(_component_LoadingFile)
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("article", _hoisted_3, [
            _createVNode(_component_ErrorFile, { message: _ctx.error }, null, 8, ["message"])
          ]))
        : _createCommentVNode("", true),
    (!_ctx.loading && !_ctx.error)
      ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchImages && _ctx.searchImages(...args)), ["prevent"]))
          }, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "searchTerm",
              class: "d-flex form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              placeholder: "Buscar imágenes",
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _hoisted_8
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.images && !_ctx.loading && !_ctx.error)
      ? (_openBlock(), _createElementBlock("article", _hoisted_9, [
          _createVNode(_component_CarouselFile, { images: _ctx.images }, null, 8, ["images"])
        ]))
      : _createCommentVNode("", true)
  ]))
}